import React from 'react';

function Italic(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M16.3333 3.04163H13C12.6548 3.04163 12.375 2.76181 12.375 2.41663C12.375 2.10283 12.6063 1.84304 12.9076 1.7984L13 1.79163H17.3631C17.3714 1.79146 17.3797 1.79146 17.3879 1.79163H21.75C22.0952 1.79163 22.375 2.07145 22.375 2.41663C22.375 2.73043 22.1437 2.99021 21.8424 3.03485L21.75 3.04163H17.75L8.41667 20.5416H11.75C12.0952 20.5416 12.375 20.8214 12.375 21.1666C12.375 21.4804 12.1437 21.7402 11.8424 21.7849L11.75 21.7916H7.38685C7.3786 21.7918 7.37034 21.7918 7.36208 21.7916H3C2.65482 21.7916 2.375 21.5118 2.375 21.1666C2.375 20.8528 2.60626 20.593 2.90764 20.5484L3 20.5416H7L16.3333 3.04163Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Italic;
